import { Company } from "models/Company";
import { useAuth } from "react-oidc-context";
import { newsLetterService } from "services/Services";
import { useEffect, useState } from "react";
import NewsLetterNag from "./NewsLetterNag";

type NewsLetterConsentProp = {
    companies: Company[] | null;
};

const NewsLetterConsent = ({ companies }: NewsLetterConsentProp) => {
    const auth = useAuth();

    const [checked, setChecked] = useState<boolean | null>(null);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        let isMounted = true;

        (async () => {
            try {
                const res = await newsLetterService.GetStatus();
                if (!isMounted) return;

                if (res !== undefined) {
                    setChecked(res.isActive);
                } else {
                    setChecked(false); // sensible fallback
                }
            } catch (err) {
                console.error("Failed to get newsletter status:", err);
                setChecked(false); // fallback on error
            }
        })();

        return () => {
            isMounted = false;
        };
    }, []);

    // Controlled change handler
    const handleToggle = async (isChecked: boolean) => {
        setChecked(isChecked);
        try {
            setSaving(true);
            await newsLetterService.ToggleNewsLetter(isChecked);
            localStorage.setItem("newsletter_nag_timestamp", new Date().toISOString());
        } catch (err) {
            setChecked((prev) => !prev);
        } finally {
            setSaving(false);
        }
    };

    if (!auth.user?.profile.email) return <></>;

     const paidCompanies = companies?.filter((x) => x.hasProducts && x.hasStats);
     const hasPayingCompanies = paidCompanies && paidCompanies.length > 0;
    
     if (hasPayingCompanies)
          return <></>;

    // Don't render checkbox until initial value is known
    if (checked === null) return <></>;
    
    

    return (
        <>
            <div className="form-check">
                { saving ? <span className="spinner-border spinner-border-sm form-check-input"></span> : <input
                    className="form-check-input"
                    type="checkbox"
                    id="nyhetsbrev"
                    checked={checked}
                    onChange={(e) => handleToggle(e.target.checked)}
                    disabled={saving}
                />}
                <label className="form-check-label small" htmlFor="nyhetsbrev">
                    Jeg ønsker å motta nyhetsbrev fra 1881
                </label>{" "}
                <span
                    className="d-inline-block small a"
                    role="button"
                    data-bs-toggle="modal"
                    data-bs-target="#modalNewsLetter"
                >
                    Les mer
                </span>
            </div>
            <NewsLetterNag checked={checked} saving={saving} onValueChange={handleToggle}/>
        </>
    );
};

export default NewsLetterConsent;